import {UI} from "../../../stem-core/ui/UIBase";
import {LoadingSpinner} from "../../../core/ui/LoadingSpinner.jsx";

// The element loadBefore wraps: the mixin below sets these on it while the load runs
interface LoadingElement {
    options: Record<string, any>;
    loaderError?: any;
}

export let defaultLoadingRender = (options: Record<string, any>, uiElement: LoadingElement) => <LoadingSpinner />;
export let defaultErrorRender = (options: Record<string, any>, uiElement: LoadingElement) =><strong>Loading error: {uiElement.loaderError}</strong>;

export function loadBefore(loader: (options: Record<string, any>, uiElement: any) => Promise<any>, options: Record<string, any> = {}) {
    const loadingRender = options.loadingRender || defaultLoadingRender;
    const errorRender = options.errorRender || defaultErrorRender;

    // TODO @Mihai overwrite prototype
    // Generic so the decorator gives back the class it wrapped, which is what a class decorator must return
    return <T extends new (...args: any[]) => any>(UIClass: T) => class UIElement extends UIClass {
        render() {
            if (!this.finishedLoading) {
                return loadingRender(this.options, this);
            }

            if (this.loaderError) {
                return errorRender(this.options, this);
            }

            return super.render();
        }

        async onMount() {
            super.onMount();
            this.finishedLoading = false;
            try {
                this.loaderResponse = await loader(this.options, this); // Forward our options to the loader
                this.finishedLoading = true;
            } catch (error) {
                console.log("Loading Error: ", error);
                this.loaderError = error;
            }

            this.redraw();
        }
    }
}
